import { returnAPIdata } from '../../interfaces/chat';

export async function accountDetailsRequestHandler(
  url: string,
  requestOptions: any,
  errorMessage: string,
): Promise<returnAPIdata> {
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        return {
          data: json,
          status: 200,
        };
      } else if (response.status === 403) {
        return {
          errorMessage: 'invalid_session',
          status: response.status,
        };
      } else {
        return {
          errorMessage: errorMessage,
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: errorMessage,
      };
    });
}

export async function addAccountRequestHandler(url: string, requestOptions: any): Promise<returnAPIdata | null> {
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 403) {
        return {
          status: 403,
        };
      } else {
        const json = await response.json();

        return {
          data: json,
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return null;
    });
}

export async function deleteAccountRequestHandler(
  url: string,
  requestOptions: any,
  errorMessage: string,
): Promise<returnAPIdata> {
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        return {
          status: 200,
        };
      } else if (response.status === 403) {
        return {
          errorMessage: 'invalid_session',
          status: response.status,
        };
      } else {
        return {
          errorMessage: errorMessage,
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: errorMessage,
      };
    });
}
